import {
  FETCH_CUSTOMER,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  GET_CUSTOMER,
  GET_CUSTOMER_CONTACTS,
  EDIT_CUSTOMER_CONTACT,
  CREATE_CUSTOMER_CONTACT,
  EDITED_CUSTOMER,
  DELETE_CUSTOMER,
  ERROR
} from "../actions/types";

const INITIAL_STATE = {
  loading: false,
  error: false,
  deleteSuccess: false,
  error_message: '',
  customerList: [],
  customerContactsList: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {

    case FETCH_CUSTOMER:
      return {
        ...state
      };

    case CREATE_CUSTOMER:
      return {
        ...state,
        loading: true
      }
    case EDITED_CUSTOMER:
      return {
        ...state,
        editedCustomer: action.payload,
        loading: false

      }
    case EDIT_CUSTOMER_CONTACT:
      return {
        ...state,
        editedCustomerContact: action.payload,
        loading: false
      }
    case CREATE_CUSTOMER_CONTACT:
      return {
        ...state,
        newCustomerContact: action.payload,
        loading: false
      }
    case CREATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        newCustomer: action.payload
      };
    case DELETE_CUSTOMER:
      return {
        ...state,
        loading: false,
        deleteSuccess: action.payload
      };
    case GET_CUSTOMER:
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
        customerList: action.payload
      };
    case GET_CUSTOMER_CONTACTS:
      return {
        ...state,
        customerContactsList: action.payload
      };
    case ERROR:
      return {
        ...state,
        error_validation: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
};